import { ApiService } from '@/axios'

export const login = (identifier, password) => {
    return ApiService.postLogin('auth/local', { identifier, password })
}

